// extracted by mini-css-extract-plugin
export default {"member":"UserCard_member__gl4k3","pic":"UserCard_pic__Zzia3","member_info":"UserCard_member_info__YnaVT","social":"UserCard_social__OVucU"};